exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back_div[data-v-2e127c1a]{background-color:#d3d3d3}.info_text[data-v-2e127c1a]{color:red;font-size:15px}.user_div[data-v-2e127c1a]{margin-top:2px}.user_name_div[data-v-2e127c1a]{font-size:16px;color:#323233}.user_desc2_div[data-v-2e127c1a],.user_desc_div[data-v-2e127c1a]{font-size:12px;color:#6e6e70}", ""]);

// exports
